// extracted by mini-css-extract-plugin
export default {"container":"partsList_container__WgbHX","subContainer":"partsList_subContainer__UddI9","separator":"partsList_separator__Fj5PM"};